import { NgIf } from "@angular/common";
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { DxButtonModule } from "devextreme-angular";
import { ImageCropperComponent, ImageCroppedEvent } from "ngx-image-cropper";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
    selector: "app-image-cropper",
    imports: [NgIf, DxButtonModule, ImageCropperComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <div *ngIf="file">
      <div>
        <image-cropper
          [imageFile]="file"
          [maintainAspectRatio]="true"
          [aspectRatio]="aspectRatio"
          format="png"
          (imageCropped)="imageCropped($event)"
        ></image-cropper>
      </div>

      <div style="justify-content: center; display: flex; margin-top: 10px">
        <dx-button
          i18n-text="@@confirmCaps"
          text="CONFIRM"
          (onClick)="finishedCropping()"
        ></dx-button>
      </div>
    </div>
  `
})
export class CustomImageCropper {
  @Input() file!: File; // raw file from parent
  @Input() aspectRatio: number = 1; // square, wide, etc
  @Output() croppedImageEmitter = new EventEmitter<Blob>(); // sends cropped image to parent

  croppedImage: SafeUrl = "";
  private lastCroppedBlob: Blob | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  imageCropped(event: ImageCroppedEvent) {
    if (event.objectUrl && event.objectUrl.startsWith("blob:")) {
      this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
        event.objectUrl,
      );
    } else {
      this.croppedImage = null;
    }
    this.lastCroppedBlob = event.blob;
  }

  finishedCropping() {
    if (this.lastCroppedBlob) {
      this.croppedImageEmitter.emit(this.lastCroppedBlob);
    }
  }
}
